// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Z1dh","inner":"styles_inner__2BNxH","right":"styles_right__HeO1n","close":"styles_close__qPqDH","footer":"styles_footer__3Lbp9"};